<script>
import cardportfolio from 'Components/card-portfolio'

export default {
  name: 'cardCommercial',
  components: {
    cardportfolio
  },
  data: () => ({
    dialog: false,
    projects: [
      {
        title: 'Zodiac Nautic',
        subtitle: 'Semi inflatable boats',
        text: 'A bespoke configurator. Lots of color options and different products to choose from. Review and checkout your design and get a pdf with your design emailed to you automatically.',
        articleurl: 'https://www.klaasnienhuis.nl/2016/07/zodiac-nautic-boat-configurator/',
        url: 'https://configure.zodiac-nautic.com/',
        img: './img/zodiac.jpg'
      },
      {
        title: 'F.Domes',
        subtitle: 'Geodetic dome tents',
        text: 'A custom configurator with a responsive design. Speed up the sales process with live princing and shipping info.',
        articleurl: 'https://www.klaasnienhuis.nl/2018/06/f-domes-geodesic-dome-configurator/',
        url: 'https://3d.fdomes.com/',
        img: './img/fdomes.jpg'
      },
      {
        title: 'Gasgrill',
        subtitle: 'Professional gas grills',
        text: 'A responsive configurator with robust logic and rules. Create your new grill on your laptop or mobile and step into a live co-creation session with a sales agent.',
        articleurl: 'https://www.klaasnienhuis.nl',
        url: 'https://www.gasgrill-shop.com/3d-konfigurator/index.html#/',
        img: './img/gasgrill.jpg'
      }
    ]
  }),
  computed: {
    dialogColumns () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '12'
        case 'sm': return '12'
        case 'md': return '6'
        case 'lg': return '4'
        case 'xl': return '4'
        default: return '6'
      }
    },
    bigcard () {
      return this.$store.getters['ui/getItemByName']('cardcommercialbig')
    },
    dialogWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'sm': return 600
        case 'md': return 800
        case 'lg': return 1000
        case 'xl': return 1200
        default: return 800
      }
    },    
  },

  methods: {
  },
  mounted () {
  }
}
</script>

<template>
<v-card color="card" elevation=0>
  <v-list-item v-if="bigcard">
    <v-list-item-avatar>
      <v-img src="../assets/img/Klaas_profilePicture.jpg"></v-img>      
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="headline">Klaas Nienhuis</v-list-item-title>
      <v-list-item-subtitle color="black">3D development</v-list-item-subtitle>
    </v-list-item-content> 
  </v-list-item>
  <!-- <v-divider></v-divider> -->

  <v-card-text v-if="bigcard" class="px-7 py-0 textcontrast--text">
      Hi, I'm Klaas and I've built this demo. Get in touch to work with a team of specialists. We're experienced in building 3d configurators from A to Z.
  </v-card-text>

  <v-card-actions>
        <p v-if="!bigcard" class="headline mt-2 ml-2 mb-1">Klaas Nienhuis</p>

    <v-spacer></v-spacer>  
    
    <v-dialog
      v-model="dialog"
      :width=dialogWidth
      :fullscreen="$vuetify.breakpoint.xsOnly"
      
    >
    <v-card>
      <v-container fluid>
        <v-row dense>
          <v-col
            v-for="project in projects"
            :key="project.title"
            :cols=dialogColumns
          >
            <cardportfolio :project="project">
            </cardportfolio>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          large
          @click="dialog = false"
        >
          OK Cool
        </v-btn>
      </v-card-actions>          
        </v-card>
    </v-dialog>
<v-item-group>
      <v-btn color="primary mr-1 mt-1" @click.stop="dialog = true">
      <span v-if="bigcard">Projects</span>
      <v-icon v-if="!bigcard">mdi-information-outline</v-icon>
    </v-btn>

    <v-btn color="primary mt-1" href="https://klaasnienhuis.freshsales.io/web_forms/404bcc64bc2b7d2fadc81f06d07264e35c21a9cc6c36e680a1bd52d8b929b501/form.html" target="_blank">
      <span v-if="bigcard">Contact</span>
      <v-icon v-if="!bigcard">mdi-email</v-icon>
    </v-btn>
</v-item-group>
  </v-card-actions>
</v-card>
</template>

<style lang="scss" scoped>
.loader {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
